/** Flip to false on launch day so the storefront and API both open purchases. */
export const PURCHASES_LOCKED_UNTIL_LAUNCH = false;
